import { OrderItem } from '@shop/models/src/order.js';
import { ProductState } from './product-state.js';
import { ShipmentMethod, consts } from './constants/index.js';
import { Voucher } from '@shop/models/src/voucher.js';

export function getOrderState({
  items,
  shipment,
  voucher,
}: {
  items: OrderItem[];
  shipment?: ShipmentMethod | ShipmentMethod['id'];
  voucher?: Voucher | null;
}) {
  if (typeof shipment === 'string') {
    shipment = consts.shipmentMethods.find((s) => s.id === shipment);
  }

  let amount = 0,
    discount = 0;

  for (const item of items) {
    const manager = new ProductState(item.product, item.project, item.props);
    const state = manager.state();
    amount += state.price * item.qty;
    discount += state.discount.price * item.qty;
  }

  let payableAmount = amount + (shipment?.price ?? 0) - discount;

  let voucherDiscount = 0;
  if (voucher != null) {
    voucherDiscount = calculateVoucherDiscount(voucher, payableAmount);
    payableAmount = Math.max(0, payableAmount - voucherDiscount);
    discount += voucherDiscount;
  }

  return {
    amount,
    discount,
    payableAmount,
    shipment,
    voucher: {
      ...voucher,
      discountAmount: voucherDiscount,
    },
    isFullDiscount: payableAmount === 0,
  };
}

export function calculateVoucherDiscount(
  voucher: Voucher,
  purchaseAmount: number,
) {
  let discountAmount = 0;
  switch (voucher.discountType) {
    case 'fixed_amount': {
      discountAmount = Math.min(voucher.discountValue, purchaseAmount);
      break;
    }
    case 'percentage': {
      discountAmount = Math.round(
        (voucher.discountValue * purchaseAmount) / 100,
      );

      if (voucher.upperLimit != null && discountAmount > voucher.upperLimit) {
        discountAmount = voucher.upperLimit;
      }

      break;
    }
    default: {
      throw new Error('unsupported discount type');
    }
  }

  return discountAmount;
}

export type OrderState = ReturnType<typeof getOrderState>;
